import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-roll-fin-grid',
  templateUrl: './time-roll-fin-grid.component.html',
  styleUrls: ['./time-roll-fin-grid.component.css']
})
export class TimeRollFinGridComponent implements OnInit {

  title="Time Roll Finalization";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-grid/time-roll-fin-grid.component.ts